import { render, staticRenderFns } from "./AppHeaderItemControl.vue?vue&type=template&id=13204751&"
import script from "./AppHeaderItemControl.vue?vue&type=script&lang=js&"
export * from "./AppHeaderItemControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports